export default __webpack_public_path__ + "static/AlertRecipient-2470091877e0787dc0a63b584b1510f0.png";